<template>
    <div class="d-flex flex-column align-items-center w-100">
        <div class="section-header text-center px-0">
            <div v-if="recaptchaEnabled && displayRecaptcha">
                <turnstile-widget ref="turnstileWidget" execution="execute" action="form-submission" @verified="handleRecaptchaToken" @errored="handleRecaptchaError" @expired="clearRecaptcha" @timedOut="clearRecaptcha" @retrying="clearRecaptcha" @interactiveStart="pauseRecaptchaWait" @interactiveEnd="resumeRecaptchaWait"></turnstile-widget>
                <validation-message v-if="recaptchaMessage" :message="recaptchaMessage"></validation-message>
            </div>
            <terms-checkbox v-model="termsAccepted" :disabled="loading || unknownStatus" @displayTerms="displayTerms"></terms-checkbox>
            <validation-message v-if="termsMessage" :message="termsMessage" class="mb-2"></validation-message>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
    import { mapActions, mapMutations } from 'vuex';
    import { ErrorHelper } from '@/helpers/ErrorHelper'
    import { BookingAddMixin } from '@/mixins/Booking/BookingAddMixin'
    import { SiteBookingSettingMixin } from '@/mixins/Booking/SiteBookingSettingMixin';
    import { SiteBookingResourceOrderSettingMixin } from '@/mixins/Booking/SiteBookingResourceOrderSettingMixin';
    import ValidationMessage from '@/components/ErrorValidation/ValidationMessage.vue';
    import TurnstileWidget from '../TurnstileWidget.vue';
    import TermsAndConditionsCheckbox from '../TermsAndConditionsCheckbox.vue';

    export default {
        name: 'BookingAdd',
        mixins: [BookingAddMixin, SiteBookingSettingMixin, SiteBookingResourceOrderSettingMixin],
        computed: {
            participants() {
                const { selectedPets, resourceIds } = this.bookingUploadModel;

                // Map of resourceId to its index in resourcesForNewClients
                const resourceIdToIndexMap = new Map();
                this.resourcesForNewClients.forEach((id, index) => {
                    resourceIdToIndexMap.set(id, index);
                });

                const sortedResourceIdsInMap = resourceIds.sort((a, b) => resourceIdToIndexMap.get(a) - resourceIdToIndexMap.get(b));

                if(!(selectedPets.length > 0 && sortedResourceIdsInMap.length > 0)) return [];

                return selectedPets.map((pet, i) => ({
                    ...pet,
                    resourceId: this.siteBookingSettingSinglePetResourceEnabled ? sortedResourceIdsInMap[i] : sortedResourceIdsInMap[0],
                    serviceItems: pet.serviceItems.map(item => ({ ...item, quantity: 1 }))
                }));
            }
        },
        watch: {
            participants(value) {
                this.setParticipants(value);
            }
        },
        beforeDestroy() {
            this.setParticipants([]);
        },
        methods: {
            ...mapMutations('BookingUpload', [
                'setParticipants'
            ]),
            ...mapActions('Booking', [
                'addBookingAnonymous'
            ]),
            tryAddBooking() {
                const self = this;
                self.error = '';
                if(!self.bookingAddModelValid || !self.selectedSiteId) {
                    return;
                }
                self.addBookingAnonymous({siteId: self.selectedSiteId, payload: self.bookingAddModel, router: self.$router })
                    .catch(error => { 
                        self.error = ErrorHelper.getError(error);
                        self.resetRecaptcha();
                    });
            }
        },
        components: {
            'validation-message': ValidationMessage,
            'turnstile-widget': TurnstileWidget,
            'terms-checkbox': TermsAndConditionsCheckbox
        }
    }
</script>
